import { ShapeCombo, ShapeComboOptions } from "../Shape";
import BallShape from "./BallShape";
import RectShape from "./RectShape";
import { toRadian } from "@zyzgroup/core-common";

export type SegmentShapeComboOptions = {
  segmentWidth: number; // 2个控制点之间的距离
  segmentHeight: number;
  segmentCornerRadius?: number;
} & ShapeComboOptions;

export class SegmentShapeCombo extends ShapeCombo {
  width: number;
  height: number;
  cornerRadius: number;

  constructor(options: SegmentShapeComboOptions) {
    super(options);

    this.width = options.segmentWidth;
    this.height = options.segmentHeight;

    this.cornerRadius =
      typeof options.segmentCornerRadius == "number"
        ? options.segmentCornerRadius
        : this.height * 0.5;

    // 圆柱体
    const mainRect = new RectShape({
      drag: {
        followSibling: true
      },
      rectWidth: this.width + this.cornerRadius * 2,
      rectHeight: this.height,
      rectBorderRadius: this.cornerRadius
    });
    this.addShape(mainRect, {
      dX: 0 - this.cornerRadius,
      dY: 0 - this.height * 0.5
    });

    // 左点 - 控制点
    const controlPoint = new BallShape({
      drag: {
        followSibling: true
      },
      ballRadius: 2
    });
    this.addShape(controlPoint);

    // 右点
    const rightPoint = new BallShape({
      drag: {
        followSibling: true
      },
      ballRadius: 2
    });
    this.addShape(rightPoint, { dX: 0 + this.width });
  }

  protected cloneShapeCombo(): SegmentShapeCombo {
    const shapeCombo = new SegmentShapeCombo({
      ...super.getBaseOptions(),
      segmentWidth: this.width,
      segmentHeight: this.height,
      segmentCornerRadius: this.cornerRadius
    });
    return shapeCombo;
  }

  // 重写覆盖
  public getBoundingClientRectCenter() {
    return {
      x: 0,
      y: 0
    };
  }

  // 绝对值
  getPin() {
    const controlPoint = this.shapes[1];
    return {
      x: controlPoint.x + Math.cos(toRadian(controlPoint.degree)) * this.width,
      y: controlPoint.y + Math.sin(toRadian(controlPoint.degree)) * this.width
    };
  }
}

export default SegmentShapeCombo;
